// src/components/result/ResultCard.js
import React from "react";

export function ResultCard({
  title,
  subtitle,
  actions,
  children,
  className = "",
}) {
  return (
    <div className={`flex flex-col gap-4 h-fit ${className}`}>
      {/* Header */}
      <div className="flex flex-col items-start justify-start">
        <h2 className="subtitle-text !text-primary">{title}</h2>
        {subtitle && <div className="muted-text !text-xs">{subtitle}</div>}
      </div>

      {/* Body */}
      {children}

      {/* Optional actions row (icons, menu, etc.) */}
      {actions && (
        <div className="flex items-center justify-end gap-2">{actions}</div>
      )}
    </div>
  );
}
